<div
  [formGroup]="block()"
  class="grid grid-cols-1 gap-4 lg:grid-cols-[12rem_minmax(0,1fr)]">
  <div class="text-standard-text-secondary pt-3 pl-8 text-sm font-semibold">
    {{ cmsTextProvider.footer.freeText }}
  </div>
  <div class="flex-1">
    <aw-translation-text-area
      [entityType]="EntityType.footerAddressArea"
      [relationType]="TextRelationType.text"
      [id]="'block-text-' + index()"
      [formControl]="block().controls.texts"
      [label]="''"></aw-translation-text-area>
  </div>
</div>
